<template>
  <section>
    <!-- GDPR info -->
    <div class="mb-6 flex flex-col sm:flex-row gap-4">
      <div class="submission-info-box flex-1 border border-yellow-300 bg-yellow-50 p-5 text-sm text-yellow-800">
        {{ wt('projectSubmission', 'consent', 'gdprAnonymized') }}
      </div>
      <div class="submission-info-box flex-1 border border-yellow-300 bg-yellow-50 p-5 text-sm text-yellow-800">
        {{ wt('projectSubmission', 'consent', 'gdprFreetext') }}
      </div>
    </div>

    <!-- Consent checkbox -->
    <div class="core-form-checkbox mb-2 !justify-start">
      <input
        type="checkbox"
        id="submission-consent"
        v-model="consent"
        class="relative mr-3 h-6 w-6 shrink-0 cursor-pointer"
        :class="{ 'border-red-400': errors['consent'] }" />
      <label for="submission-consent" class="cursor-pointer text-sm text-neutral-550 leading-relaxed">
        {{ wt('projectSubmission', 'consent', 'checkboxLabel') }}
      </label>
    </div>
    <p v-if="errors['consent']" class="text-sm text-red-400 mb-4">
      {{ errors['consent'] }}
    </p>

    <!-- Send button -->
    <div class="mt-6 flex items-center gap-4">
      <button
        class="h-11 px-6 inline-flex items-center gap-2 core-action-button core-action-button--primary"
        :disabled="submitting"
        :class="{ disabled: submitting }"
        @click="$emit('submit')">
        <span v-if="submitting">...</span>
        <span v-else>{{ wt('projectSubmission', 'consent', 'sendButton') }}</span>
      </button>

      <!-- Error message -->
      <p v-if="submitError" class="text-sm text-red-400">
        {{ wt('projectSubmission', 'consent', 'errorMessage') }}
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useWidgetText } from '@/helpers/useWidgetText'

const { wt } = useWidgetText('widget-texts-project-summary')

const consent = defineModel<boolean>('consent', { required: true })

defineProps<{
  submitting: boolean
  submitError: boolean
  errors: Record<string, string>
}>()

defineEmits<{
  (e: 'submit'): void
}>()
</script>

<style lang="postcss" scoped>
.submission-info-box {
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.12),
    0 8px 16px -12px rgba(0, 0, 0, 0.2),
    0 3px 7px -7px color-mix(in srgb, #facc15 20%, transparent);
}
</style>
